<template>
  <div>
    <v-divider></v-divider>

    <v-list
      subheader
      two-line
    >
      <v-subheader>{{ inputName }}</v-subheader>

      <v-list-item-group
        multiple
        active-class=""
        class="px-6"
      >
        <image-file-input-viewer
          class="mt-2"
          maxHeight="150"
          label="Section BG image"
          v-model="sectionData.bg_thumbnail"
          :clearable="true"
        />

        <v-checkbox
          label="Hide BG Image"
          v-show="sectionData.bg_thumbnail"
          v-model="sectionData.hide_bg_image"
        />
        <color-picker
          label="Section BG color"
          v-bind:color.sync="sectionData.bg_color"
        />
      </v-list-item-group>
    </v-list>

    <v-divider></v-divider>

    <v-list
      flat
      subheader
    >
      <v-subheader>Content</v-subheader>

      <v-list-item-group
        multiple
        active-class=""
        class="px-6"
      >

        <v-text-field
          v-model="sectionData[sectionData.type].title"
          outlined
          label="Section Header Text"
          dense
          class="mt-5"
          :errorMessages="serviceTitleError(head(errorMessages['page_sections.'+ currIndex + '.page_service.title' ]))"
        />

        <image-file-input-viewer
          maxHeight="150"
          label="Image"
          v-model="sectionData[sectionData.type].thumbnail"
          :clearable="true"
          v-bind:removeImage.sync="sectionData[sectionData.type].thumbnail_deleted"
        />

        <v-checkbox
          label="Remove Image"
          v-show="sectionData[sectionData.type].thumbnail && sectionData[sectionData.type].thumbnail.id"
          v-model="sectionData[sectionData.type].thumbnail_deleted"
        />

        <image-file-input-viewer
          maxHeight="150"
          label="Mobile Image"
          v-model="sectionData[sectionData.type].thumbnail_mobile"
          :clearable="true"
          v-bind:removeImage.sync="sectionData[sectionData.type].mobile_thumbnail_deleted"
        />

        <v-checkbox
          label="Remove Mobile Image"
          v-show="sectionData[sectionData.type].thumbnail_mobile && sectionData[sectionData.type].thumbnail_mobile.id"
          v-model="sectionData[sectionData.type].mobile_thumbnail_deleted"
        />

        <label class="subtitle-1 pb-3 pt-1 mt-4">Properties</label>
        <v-divider class="mt-2" />

        <color-picker
          class="mt-5"
          label="Font color"
          v-bind:color.sync="sectionData[sectionData.type].props[0].color"
        />

        <v-text-field
          v-model="sectionData[sectionData.type].props[0].size"
          outlined
          label="Font Size(px)"
          type="number"
        />

        <v-select
          label="Font Weight"
          v-model="sectionData[sectionData.type].props[0].style"
          outlined
          :items="txtWeightOptions"
        />
      </v-list-item-group>
    </v-list>
  </div>
</template>

<script>
import ImageFileInputViewer from '@/components/ImageFileInputViewer'
import ColorPicker from '@/components/ColorPicker'
import has from 'lodash/has'
import head from 'lodash/head'

export default {
  name: 'PageService',
  data () {
    return {
      txtWeightOptions: [
        '300',
        '400',
        '500',
        '600'
      ]
    }
  },
  components: {
    ImageFileInputViewer,
    ColorPicker
  },
  props: {
    sectionData: {
      type: Object,
      default () {
        return {}
      }
    },
    inputName: {
      type: String,
      default: ''
    },
    errorMessages: {
      type: [String, Array, Object],
      default () {
        return null
      }
    },
    currIndex: {
      type: [String, Number],
      default: null
    }
  },
  methods: {
    head,
    setDefaults () {
      if (!has(this.sectionData[this.sectionData.type], 'props') || this.sectionData[this.sectionData.type].props.length === 0) {
        this.sectionData.props = [
          {
            column_name: 'title',
            color: '#000000',
            size: null,
            style: null
          }
        ]
      }
      // else {
      //   this.sectionData.props[0].color = '#3F51B5'
      // }
      // if (!this.sectionData.bg_color) {
      //   this.sectionData.bg_color = '#3F51B5'
      // }
    },
    serviceTitleError (errorString) {
      if (errorString) {
        return 'Service Title is required'
      } else {
        return null
      }
    }
  },
  created () {
    this.setDefaults()
  }

}
</script>

<style scoped>
.header-btns {
  color: #df4661;
  cursor: pointer;
}
.withdrawal-options {
  margin-top: 20px;
}
</style>
